export class Totaling {
    Type: number;
    Ids: string;
    Names: string;
    Descriptions: string;
    TotalingIndex: number;
}
